import { useEffect, useCallback } from 'react';

/**
 * Hook para escuchar cambios de sede y refrescar datos automáticamente
 * @param {Function} refreshFunction - Función que se ejecutará cuando cambie la sede
 * @param {Array} dependencies - Dependencias adicionales para el useEffect
 */
export const useSedeRefresh = (refreshFunction, dependencies = []) => {
  const handleSedeChange = useCallback((event) => {
    refreshFunction();
  }, [refreshFunction]);

  useEffect(() => {
    // Escuchar el evento personalizado de cambio de sede
    window.addEventListener('sedeChanged', handleSedeChange);
    
    // Cleanup
    return () => {
      window.removeEventListener('sedeChanged', handleSedeChange);
    };
  }, [handleSedeChange]); // Remover dependencies para evitar re-renders innecesarios
};

export default useSedeRefresh;
